import styled from "styled-components";

// Pílula "amostra + valor" das cores da marca, extraída para servir também ao
// Hex do ColorPicker. O projeto não usa ThemeProvider: o tema vem por prop.
export const ColorDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: ${(props) => props.theme.colors.primary};
  background-color: ${(props) => props.theme.colors.background2};
  border-radius: 2rem;
  padding: 0.5rem 1rem 0.5rem 0.5rem;

  .color-preview {
    width: 8rem;
    height: 3rem;
    flex-shrink: 0;
    border-radius: 8px;
    /* A largura/estilo ficam aqui porque só borderColor vinha inline — sem estes
       dois a borda nunca desenhava e uma cor branca sumia no fundo do campo. */
    border: 1px solid ${(props) => props.theme.colors.placeholder};

    &.clicavel {
      cursor: pointer;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .color-code {
    color: ${(props) => props.theme.colors.tertiary};
    text-transform: uppercase;
    min-width: 7rem;
  }
`;
